<template>
  <div>
    <div id="stiky-component">
      <div class="only-sticky">
        <slot name="only-sticky" />
      </div>

      <div>
        <slot name="body" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export default defineNuxtComponent({
  setup() {
    let oldScroll: any = undefined
    onMounted(() => {
      oldScroll = window.onscroll
      const header: HTMLElement | null = document.getElementById('stiky-component')

      let sticky = 0
      if (header != null) {
        sticky = header.offsetTop - 32
      }

      function onPageScroll() {
        if (!header) return
        if (window.scrollY > sticky) {
          header.classList.add('sticky')
        } else {
          header.classList.remove('sticky')
        }
      }

      window.onscroll = function () {
        onPageScroll()
      }
    })

    onUnmounted(() => {
      window.onscroll = oldScroll
    })

    return {

    }
  }
})
</script>

<style lang="scss" scoped>
.only-sticky {
  @apply hidden;
}
.sticky {
  @apply fixed;
  @apply top-0 z-20 left-0;
  @apply w-full;
  @apply bg-white;

  @apply pt-1;
  @apply pb-2;
  @apply px-2;
  @apply m-0;

  @apply border-b-4;
  @apply border-spl-gray-2;

  .only-sticky {
    @apply block;
  }
}
</style>
